"use client";

import { classNames } from "./class-names";

export function IconButton({
  label,
  children,
  disabled = false,
  compact = false,
  onClick,
}: Readonly<{
  label: string;
  children: React.ReactNode;
  disabled?: boolean;
  compact?: boolean;
  onClick?: () => void;
}>) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
      className={classNames(
        "inline-flex shrink-0 items-center justify-center rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand",
        compact ? "size-8" : "size-10",
        disabled
          ? "cursor-not-allowed text-zinc-300"
          : "text-zinc-600 transition hover:bg-zinc-100 hover:text-zinc-950",
      )}
    >
      {children}
    </button>
  );
}
